import axios from 'axios';

export async function GetGroup1Data() {
    try {
        const response = await axios.post("/api/shop/g1", {});
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export async function GetGroup2Data() {
    try {
        const response = await axios.post("/api/shop/g2", {});
        return response.data;
    } catch (error) {
        console.error(error);
    }
};